module.exports = __webpack_public_path__ + "static/media/expressjs.88487091.png";